import { createContext } from 'react';

import { MultiSelectContextType } from '../../utils/types/stateful-list.types';

export const MultiSelectContext = createContext<MultiSelectContextType | null>(null);
